import React from "react";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";

function Footer({ data }) {
  if (!data) return null;

  return (
    <footer className="home-footer">
      <div className="page-shell">
        <div className="footer-cta">
          <div>
            <p className="section-kicker section-kicker--dark">Have a problem worth solving?</p>
            <h2>Let&apos;s talk.</h2>
          </div>
          <a className="button button--light" href={`mailto:${data.email}`}>
            {data.email}
          </a>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} {data.namelong}</p>
          <div className="footer-socials">
            {data.social?.map((network) => (
              <a key={network.name} href={network.url} target="_blank" rel="noreferrer">
                {network.name}
              </a>
            ))}
          </div>
          <a className="back-to-top" href="#home" aria-label="Back to top">
            <ArrowUpwardRoundedIcon />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
